export default "__VITE_ASSET__CCdQDe$Q__"